package com.gsb.vyapar.bhagya.theme

import gsb_vyparbhagya.composeapp.generated.resources.*
import org.jetbrains.compose.resources.DrawableResource

val visibility_on = Res.drawable.visibility_on
val visibility_off = Res.drawable.visibility_off
val arrow_up = Res.drawable.arrow_up
val arrow_down = Res.drawable.arrow_down
val splash = Res.drawable.splash
val home = Res.drawable.home
val category = Res.drawable.category
val latest = Res.drawable.latest
val favorites = Res.drawable.favorites
val placeHolder = Res.drawable.placeholder
val facebook = Res.drawable.facebook
val instagram = Res.drawable.instagram
val mail = Res.drawable.mail
val twitter = Res.drawable.twitter
val web = Res.drawable.web
val whatsapp = Res.drawable.whatsapp
val applestore = Res.drawable.applestore
val googlestore = Res.drawable.googlestore
val webstore = Res.drawable.webstore
val call = Res.drawable.call
val add_icon = Res.drawable.add_icon
val sucess = Res.drawable.sucess
val failure = Res.drawable.failure
val address = Res.drawable.address
val arrow_back = Res.drawable.arrow_back
val edit_icon = Res.drawable.edit
val delete_icon = Res.drawable.delete
val search_icon = Res.drawable.search
val thumb_up = Res.drawable.thumb_up
val star = Res.drawable.star
val menu_icon = Res.drawable.menu
val location_icon = Res.drawable.location
val account_circle = Res.drawable.account_circle
val info = Res.drawable.info
val service = Res.drawable._10
val youtube = Res.drawable.youtube
val linkedin = Res.drawable.linkedin
val close = Res.drawable.close
val googlemaps = Res.drawable.googlemaps
val fav_on = Res.drawable.fav_on
val fav_off = Res.drawable.fav_off
val direction = Res.drawable.direction
val share = Res.drawable.share
val right = Res.drawable.right
val left = Res.drawable.left
val rotateleft = Res.drawable.rotateleft
val rotateright = Res.drawable.rotateright
val close_black = Res.drawable.close_black
val view_full_map = Res.drawable.view_full_map

fun getImageForCategory(id: Int): DrawableResource {
    return when (id) {
        1 -> Res.drawable._1
        2 -> Res.drawable._2
        3 -> Res.drawable._3
        4 -> Res.drawable._4
        5 -> Res.drawable._5
        6 -> Res.drawable._6
        7 -> Res.drawable._7
        8 -> Res.drawable._8
        9 -> Res.drawable._9
        10 -> Res.drawable._10
        11 -> Res.drawable._11
        12 -> Res.drawable._12
        13 -> Res.drawable._13
        14 -> Res.drawable._14
        15 -> Res.drawable._15
        16 -> Res.drawable._16
        17 -> Res.drawable._17
        18 -> Res.drawable._18
        else -> Res.drawable.placeholder
    }
}


